// NOTE: copy-paste from angular upgrade sources
// https://github.com/angular/angular/blob/master/packages/upgrade/src/common/downgrade_component_adapter.ts

/**
 * Group a set of DOM nodes into `ngContent` groups, based on the given content selectors.
 */
export function groupNodesBySelector(ngContentSelectors: string[], element: Node): Node[][] {
  const nodes = Array.prototype.slice.call(element.childNodes);
  const projectableNodes: Node[][] = [];

  for (let i = 0, ii = ngContentSelectors.length; i < ii; ++i) {
    // eslint-disable-next-line functional/immutable-data
    projectableNodes[i] = [];
  }

  for (let j = 0, jj = nodes.length; j < jj; ++j) {
    const node = nodes[j];
    const ngContentIndex = findMatchingNgContentIndex(node, ngContentSelectors);
    if (ngContentIndex != null) {
      // eslint-disable-next-line functional/immutable-data
      projectableNodes[ngContentIndex].push(node);
    }
  }

  return projectableNodes;
}

function findMatchingNgContentIndex(element: Element, ngContentSelectors: string[]): number | null {
  const ngContentIndices: number[] = [];
  let wildcardNgContentIndex = -1;
  for (let i = 0; i < ngContentSelectors.length; i++) {
    const selector = ngContentSelectors[i];
    if (selector === '*') {
      wildcardNgContentIndex = i;
    } else {
      if (matchesSelector(element, selector)) {
        // eslint-disable-next-line functional/immutable-data
        ngContentIndices.push(i);
      }
    }
  }
  // eslint-disable-next-line functional/immutable-data
  ngContentIndices.sort();

  if (wildcardNgContentIndex !== -1) {
    // eslint-disable-next-line functional/immutable-data
    ngContentIndices.push(wildcardNgContentIndex);
  }
  return ngContentIndices.length ? ngContentIndices[0] : null;
}

let matches: (this: Element, selector: string) => boolean;

function matchesSelector(el: Element, selector: string): boolean {
  if (!matches) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const elProto = Element.prototype as any;
    matches =
      elProto.matches ||
      elProto.matchesSelector ||
      elProto.mozMatchesSelector ||
      elProto.msMatchesSelector ||
      elProto.oMatchesSelector ||
      elProto.webkitMatchesSelector;
  }
  return el.nodeType === Node.ELEMENT_NODE ? matches.call(el, selector) : false;
}
